<template>
  <div>
    <el-timeline>
      <el-timeline-item v-for="item in list" :key="item.id" :timestamp="item.insertTime" placement="top">
        <el-card>
          <div class="content-wrapper">
            <user-photo class="user_icon" :name="item.commentUser"></user-photo>
            <div style="margin-left:10px">
              <p class="commit-desc">{{ `${item.commentUser} 提交于 ${item.insertTime}` }}</p>
              <p class="commit-text">{{ item.comment }}</p>
            </div>
          </div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <el-form-item label="" label-width="28px">
      <el-input v-model="comment" type="textarea" :rows="5" placeholder="请输入备注"></el-input>
    </el-form-item>
  </div>
</template>

<script>
import UserPhoto from '@/components/UserPhoto/index.vue'
export default {
  name: 'Comments',
  components: {
    UserPhoto
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      comment: '',
    }
  },
  watch: {
    comment(newVal) {
      this.$emit('update:comment', newVal)
    }
  }
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  color: #8c95a8;
  font-size: 12px;
}
.user_icon {
  width: 30px;
  height: 30px;
}
.commit-desc {

}
.commit-text {
  margin-top: 8px;
  color: #182b50;
  font-size: 14px;
}
</style>
